import angular from 'angular';

/**
 * @ngdoc overview
 * @name adminModule.appsDirectives
 * @description
 * # adminModule.appsDirectives
 * Module for managing the directives of applications / SDK.
 */
const appsDirectives = angular.module('adminModule.appsDirectives', []);

/**
 * @ngdoc directive
 * @name adminModule.appsDirectives.directive:appIcon
 * @description
 * Directive for displaying the application icon of mobile OS.
 */
appsDirectives.directive('appIcon', () => {
    return {
        restrict: 'AE',
        scope: {
            app: '=appIcon'
        },
        replace: true,
        controller: ['$scope', ($scope) => {
            if (angular.isDefined($scope.app)) {
                $scope.iconClass = `icon li-${$scope.app.substr($scope.app.indexOf('.') + 1).toLowerCase()}`;
            }
        }],
        template: '<i class="{{iconClass}}"></i>'
    };
});

appsDirectives.directive('reportsTreeApp', () => {
    return {
        templateUrl: 'views/admin/apps/components/tree/placeTree.tpl.html',
        replace: true,
        transclude: true,
        restrict: 'E',
        scope: {
            pages: '=ngModel',
            type: '@type',
            addpageaction: '&',
            addmoduleaction: '&',
            addmoduleelementaction: '&',
            editmoduleelementaction: '&',
            parent: '='
            //                editpage: '&'                
        }
    };
});

/**
 * @ngdoc directive
 * @name reportsModule.placesDirectives.directive:place
 * @description
 * Directive for the tree row representing the place in the reports ('list' view)
 */
appsDirectives.directive('appTree', ['$compile', ($compile) => {
    return {
        restrict: 'E',
        templateUrl: 'views/admin/apps/components/tree/appRow.tpl.html',
        link: (scope, elm) => {
            if (angular.isDefined(scope.page.children) && scope.page.children.length >= 0 && (scope.page.type === "page" || (scope.page.type === "module" && scope.page.module_type === 1))) {
                const childChoice = $compile('<reports-tree-app ng-model="page.children" parent="page" ng-show="page.showChildren" type="{{page.child_type}}" addpageaction="addpageaction()" addmoduleaction="addmoduleaction({parent: parent})" addmoduleelementaction="addmoduleelementaction({parent: parent})" editmoduleelementaction="editmoduleelementaction({$event: $event, data: data})"></reports-tree-app>')(scope);
                elm.append(childChoice);
            }
        },
        controller: ['$scope', 'TreeService', '$modal', 'growl', 'Permissions', '$translate', function ($scope, TreeService, $modal, growl, Permissions, $translate) {

            $scope.editPageAction = ($event) => {
                $event.stopImmediatePropagation();
                const modalInstance = $modal.open({
                    templateUrl: 'views/admin/apps/components/modal/page.tpl.html',
                    controller: 'PageModalController',
                    resolve: {
                        page: () => {
                            return angular.extend($scope.page, {superadmin: Permissions.hasSuperAdminAccess()});
                        }
                    }
                });
                modalInstance.result.then((data) => {
                    $scope.newPage = {
                        id: data.page.id,
                        name: data.page.name,
                        application_id: data.page.application_id,
                        children: [],
                        showChildren: false,
                        type: 'page'
                    };
                    angular.forEach($scope.pages, (page) => {
                        if (page.id === data.page.id) {
                            //                               $scope.pages[key].name = data.page.name;
                            page.name = data.page.name;
                        }
                    });
                    growl.success('MODULES.APPLICATIONS.SUCCESS.PAGE_EDITED');
                    angular.extend($scope.page, data);
                }).catch(() => {});
            };

            $scope.editModuleAction = ($event, module) => {
                $event.stopImmediatePropagation();
                $scope.module = module;
                const modalInstance = $modal.open({
                    templateUrl: 'views/admin/apps/components/modal/module.tpl.html',
                    controller: 'ModuleModalController',
                    resolve: {
                        module: () => {
                            return angular.extend($scope.module, {superadmin: Permissions.hasSuperAdminAccess()});
                        }
                    }
                });
                modalInstance.result.then((data) => {
                    $scope.newModule = {
                        id: data.module.id,
                        name: data.module.name,
                        page_id: data.module.page_id,
                        module_type: data.module.module_type,
                        template: data.module.template
                    };
                    angular.forEach($scope.pages, (module) => {
                        if (module.id === data.module.id) {
                            module.name = data.module.name;
                            module.module_type = data.module.module_type;
                            module.template = data.module.template;
                        }
                    });
                    growl.success('MODULES.APPLICATIONS.SUCCESS.MODULE_EDITED');
                    angular.extend($scope.module, data);
                }).catch(() => {});
            };

            $scope.toggleChildren = ($event, page) => {
                page.showChildren = !page.showChildren;
            };

            $scope.getIconToggleClass = (page) => {
                let iconClass = '';
                if (angular.isDefined(page.children) && page.children.length >= 0 && (page.type === "page" || (page.type === "module" && page.module_type === 1))) {
                    iconClass = page.showChildren ? 'li-arrow-down' : 'li-arrow-right';
                }

                return iconClass;
            };

            $scope.getIconClass = (page) => {
                let iconClass = '';
                switch (page.type) {
                    case 'page':
                        iconClass = 'li-app';
                        break;
                    case 'module':
                        iconClass = 'li-level';
                        break;
                    case 'module_element':
                        iconClass = 'li-level';
                        break;
                }

                return iconClass;
            };

            this.getPageTooltip = (page) => {
                let tooltip = '';
                if (angular.isDefined(page.type)) {
                    tooltip = $translate.instant(`MODULES.PLACES.TOOLTIP.${page.type.toUpperCase()}`);
                }

                return tooltip;
            };

            // $scope.getIconToggleClass = TreeService.getIconToggleClass;
            // $scope.getIconClass = TreeService.getIconClass;
            // $scope.getPlaceTooltip = TreeService.getPlaceTooltip;
        }]
    };
}]);

/**
 * @ngdoc directive
 * @name appsDirectives.appsDirectives.directive:applicationsList
 * @description
 * Directive for displaying the list of applications
 */
appsDirectives.directive('applicationsList', () => {
    return {
        restrict: 'A',
        controller: ['$scope', 'NgTableParams', 'AppsoupAPI', 'App', ($scope, NgTableParams, AppsoupAPI, App) => {
            $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
                getData: (params) => {
                    $scope.isLoadingList = true;
                    return App.getList(params._params)
                        .then((response) => {
                            if (angular.isDefined(response) && response.success) {
                                const applications = response.applications;
                                $scope.systems = response.systems;

                                // update table params
                                params.total(applications.total);
                                params.count(applications.per_page);
                                params.page(applications.current_page);
                                // set new data
                                $scope.data = applications.data;
                                return applications.data;
                            }
                            return [];
                        })
                        .finally(() => {
                            $scope.isLoadingList = false;
                        });
                },
                counts: [] // hides page sizes
            });

            $scope.selectApp = (application) => {
                let index = -1;

                angular.forEach($scope.applications, (app, key) => {
                    index = app.id === application.id ? key : index;
                });

                if (index >= 0) { // Already in array
                    $scope.applications[index].m = AppsoupAPI.calculateMode(application.selected);
                } else {
                    $scope.applications.push({
                        id: application.id,
                        m: AppsoupAPI.calculateMode(application.selected)
                    });
                }
            };

            $scope.$watchGroup(['applications', 'data'], (newValues) => {
                const [selected, currentApps] = newValues;

                if (angular.isDefined(selected) && angular.isDefined(currentApps)) {
                    angular.forEach(currentApps, (app) => {
                        angular.forEach(selected, (selectedApp) => {
                            if (app.id === selectedApp.id) {
                                app.selected = AppsoupAPI.modeToObject(selectedApp.m);
                            }
                        });
                    });
                }
            });
        }],
        templateUrl: 'views/admin/apps/components/applicationsList.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name appsDirectives.appsDirectives.directive:userApplicationsList
 * @description
 * Directive for displaying the list of applications in user page
 */
appsDirectives.directive('userApplicationsList', () => {
    return {
        restrict: 'A',
        controller: ['$scope', 'NgTableParams', 'AppsoupAPI', 'App', ($scope, NgTableParams, AppsoupAPI, App) => {
            $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {name: 'asc'}}, {
                getData: (params) => {
                    if (angular.isDefined($scope.user.client_id)) {
                        $scope.isLoadingList = true;
                        return App.getList(params._params, $scope.user.client_id)
                            .then((response) => {
                                if (angular.isDefined(response) && response.success) {
                                    const applications = response.applications;
                                    $scope.systems = response.systems;

                                    // update table params
                                    params.total(applications.total);
                                    params.count(applications.per_page);
                                    params.page(applications.current_page);
                                    // set new data
                                    $scope.data = applications.data;
                                    return applications.data;
                                }
                                return [];
                            })
                            .finally(() => {
                                $scope.isLoadingList = false;
                            });
                    } else {
                        $scope.data = [];
                        return Promise.resolve([]);
                    }
                },
                counts: [] // hides page sizes
            });

            $scope.selectApp = (application) => {
                const index = $scope.applications.indexOf(application.id);

                if (application.selected) {
                    if (index < 0) {
                        $scope.applications.push(application.id);
                    }
                } else {
                    $scope.applications.splice(index, 1);
                }
            };

            $scope.$watch('user.client_id', (newValue) => {
                if (angular.isDefinedNotNull(newValue)) {
                    $scope.tableParams.reload();
                }
            });

            $scope.$watchGroup(['applications', 'data'], (newValues) => {
                const [selected, currentApps] = newValues;

                if (angular.isDefined(selected) && angular.isDefined(currentApps)) {
                    if (selected.length > 0) {
                        angular.forEach(currentApps, (app) => {
                            angular.forEach(selected, (selectedApp) => {
                                app.selected = app.selected || app.id === selectedApp;
                            });
                        });
                    } else {
                        angular.forEach(currentApps, (app) => {
                            app.selected = false;
                        });
                    }
                }
            });
        }],
        templateUrl: 'views/admin/apps/components/userApplicationsList.tpl.html'
    };
});

export default appsDirectives;
